const validationRules = {
  generic: {
    fieldNotNull: {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      }
    },
    fieldNotNullLength: {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [1, 2000]
      }
    },
    fieldNotNullLength10: {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [1, 10]
      }
    },
    fieldNotNullLength50: {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [1, 50]
      }
    },
    fieldNotNullLength255: {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [1, 255]
      }
    },
    fieldNotNullLength300: {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [1, 300]
      }
    },
    fieldNotNullLength500: {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [1, 500]
      }
    },
    'fieldNotNullLength5-15': {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [5, 15]
      }
    },
    'fieldNotNullLength3-500': {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [3, 500]
      }
    },
    checkNotNull: {
      notNullCheck: {
        message: 'SI_RULES_ERROR_REQUIRED'
      }
    },
    checkMultipleNotNull: {
      notNullCheckMultiple: {
        message: 'SI_RULES_ERROR_REQUIRED'
      }
    },
    length10: {
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [0, 10]
      }
    },
    length50: {
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [0, 50]
      }
    },
    length300: {
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [0, 300]
      }
    },
    length500: {
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [0, 500]
      }
    },
    email: {
      email: {
        message: 'SI_RULES_ERROR_EMAIL'
      },
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [0, 254]
      }
    },
    emailNotNull: {
      email: {
        message: 'SI_RULES_ERROR_EMAIL'
      },
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [1, 254]
      }
    },
    alphanumeric: {
      alphanumeric: {
        message: 'SI_RULES_ERROR_ALPHANUMERIC'
      }
    },
    alphanumericLength50: {
      alphanumeric: {
        message: 'SI_RULES_ERROR_ALPHANUMERIC'
      },
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [0, 50]
      }
    },
    alphabetical: {
      alphabetical: {
        message: 'SI_RULES_ERROR_ALPHABETICAL'
      }
    },
    alphabeticalNotNull: {
      alphabetical: {
        message: 'SI_RULES_ERROR_ALPHABETICAL'
      },
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      }
    },
    phone: {
      numeric: {
        message: 'SI_RULES_ERROR_NUMERIC'
      },
      length: {
        message: 'SI_RULES_ERROR_LENGTH',
        arguments: [9, 9]
      }
    }
  },
  numeric: {
    'minmax1-99': {
      minmax: {
        message: 'SI_RULES_ERROR_VALUE',
        arguments: [1, 99]
      }
    },
    'minmax1-500NotNull': {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      minmax: {
        message: 'SI_RULES_ERROR_VALUE',
        arguments: [1, 500]
      }
    },
    'minmax0-500NotNull': {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      minmax: {
        message: 'SI_RULES_ERROR_VALUE',
        arguments: [0, 500]
      }
    },
    float: {
      isFloat: {
        message: 'SI_RULES_ERROR_NUMERIC'
      }
    },
    floatNotNull: {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      isFloat: {
        message: 'SI_RULES_ERROR_NUMERIC'
      }
    },
    onlyInteger: {
      numeric: {
        message: 'SI_QUESTIONNAIRE_ONLY_INTEGERS'
      }
    },
    onlyIntegerNotNull: {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      numeric: {
        message: 'SI_QUESTIONNAIRE_ONLY_INTEGERS'
      }
    }
  },
  date: {
    pastOrNowNotNull: {
      notNull: {
        message: 'SI_RULES_ERROR_REQUIRED'
      },
      pastOrNow: {
        message: 'SI_RULES_ERROR_DATE_NOT_FUTURE',
      }
    }
  }
};

export {
  validationRules
};
